/**
 * ローカルストレージ操作用のサービスクラス
 * */
class LocalStorageService {
  constructor() {
    this.map = {};
  }

  /**
   * ユーザーIDを取得する
   * @return {number}
   * */
  getUserId = () => {
    let userId = this.getItem('user_id');
    if (userId !== null) {
      userId = Number(userId);
    }
    return userId;
  };

  /**
   * ロールIDを取得する
   * @return {number}
   * */
  getRoleId = () => {
    let roleId = this.getItem('role_id');
    if (roleId !== null) {
      roleId = Number(roleId);
    }
    return roleId;
  };

  /**
   * ログインIDを取得する
   * @return {string}
   * */
  getLoginId = () => {
    return this.getItem('login_id');
  };

  /**
   * ローカルストレージから値を取得する
   * すでに取得済みであれば取得済みデータを返却する
   * @param {string} key
   * @return {string} value
   * */
  getItem = key => {
    return localStorage.getItem(key);
  };

  /**
   * ローカルストレージへ値を設定する
   * @param {string} key
   * @param {object}設定する値
   * @return value
   * */
  setItem = (key, object) => {
    localStorage.setItem(key, object);
  };

  /**
   * ローカルストレージの値を消す
   * @param {string} key
   */
  removeItem = key => {
    localStorage.removeItem(key);
  };

  setRetryCount = num => {
    this.setItem('authValidationRetryCount', num);
  };

  getRetryCount = () => {
    return Number(this.getItem('authValidationRetryCount') || 0);
  };

  setIsFirstTimeAccessWorker = value => {
    this.setItem('is_first_time_access_worker', value);
  };

  getIsFirstTimeAccessWorker = () => {
    return this.getItem('is_first_time_access_worker') !== 'false';
  };

  setIsFirstTimeAccessWorkerAgency = value => {
    this.setItem('is_first_time_access_worker_agency', value);
  };

  getIsFirstTimeAccessWorkerAgency = () => {
    return this.getItem('is_first_time_access_worker_agency') !== 'false';
  };
}

export default new LocalStorageService();



// WEBPACK FOOTER //
// ./src/services/utilities/LocalStorageService.js